import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-notification__header" }
const _hoisted_2 = {
  class: "app-notification__icon",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "app-notification__title-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "app-notification__title"
}
const _hoisted_5 = { class: "app-notification__text" }

import {
	ref,
	onMounted,
	onUnmounted,
	computed
} from 'vue'
import type { Notification } from '@/composables/useNotification'
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";

interface AppNotificationItemProps {
	notification: Notification
}

interface AppNotificationItemEmits {
	(e: 'close', id: number): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotificationItem',
  props: {
    notification: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const progressBar = ref<HTMLElement | null>(null)
const animation = ref<Animation | null>(null)
const startTime = ref<number>(0)
const elapsedTime = ref<number>(0)
const isProgressPaused = ref<boolean>(false)
const isMounted = ref<boolean>(false)

const showProgressBar = computed(() => {
	return props.notification.delay! > 0 && isMounted.value
})

const handleClose = (): void => {
	emit('close', props.notification.id)
}

const startProgressAnimation = (): void => {
	if (!progressBar.value || !showProgressBar.value) return

	const remainingTime = props.notification.delay! - elapsedTime.value

	if (remainingTime <= 0) {
		handleClose()
		return
	}

	animation.value = progressBar.value.animate(
		[
			{ width: '100%' },
			{ width: '0%' }
		],
		{
			duration: remainingTime,
			easing: 'linear',
			fill: 'forwards'
		}
	)

	animation.value.onfinish = () => {
		if (!isProgressPaused.value) {
			handleClose()
		}
	}

	startTime.value = performance.now()
}

onMounted(() => {
	isMounted.value = true

	setTimeout(() => {
		startProgressAnimation()
	}, 10)
})

onUnmounted(() => {
	if (animation.value) {
		animation.value.cancel()
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
			'app-notification': true,
			[`app-notification--${_ctx.notification.type}`]: true
		}),
    role: "alert",
    "aria-live": "polite"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (['info', 'warning'].includes(_ctx.notification.type))
          ? (_openBlock(), _createBlock(AppIcon, {
              key: 0,
              name: "info-circle-outline",
              width: "18px",
              color: "currentColor"
            }))
          : (_ctx.notification.type === 'danger')
            ? (_openBlock(), _createBlock(AppIcon, {
                key: 1,
                name: "close",
                width: "18px",
                color: "currentColor"
              }))
            : (_openBlock(), _createBlock(AppIcon, {
                key: 2,
                name: "person-success",
                width: "18px",
                color: "currentColor"
              }))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.notification.title)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.notification.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.notification.text || ''), 1)
      ]),
      _createVNode(AppTooltip, {
        text: _ctx.$t('close_label')
      }, {
        activator: _withCtx(() => [
          (_ctx.notification.closable)
            ? (_openBlock(), _createBlock(AppIcon, {
                key: 0,
                class: "app-notification__close",
                name: "close",
                width: "14px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer",
                "aria-label": _ctx.$t('ui_close_notification'),
                onClick: handleClose
              }, null, 8, ["aria-label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    (showProgressBar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "progressBar",
          ref: progressBar,
          class: "app-notification__progress"
        }, null, 512))
      : _createCommentVNode("", true)
  ], 2))
}
}

})